import React from 'react';
import {Link} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';

import { PrimaryButton, SecondaryButton } from 'Components/Button';
import {
    FormHandler, Input, FileUpload, Textarea, Select, BooleanSelect, Dietaries,
    SpecialRequirements, EmergencyContactDetails, TravelDetails, Checkbox
} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';
import {MailLink} from 'Components/Utilities';

import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import SettingsLayout from 'Components/Layouts/SettingsLayout';
import AdminLayout from 'Pages/Admin/AdminLayout';
import Confirm from "Components/Partials/Modals/Confirm";
import { ModalTrigger } from "Components/Modal";
import { User } from "Services";

class Profile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = false;

    /**
     * @var state
     */
    state = {
        loading: true,
        user_id: this.props.match?.params?.user ?? null,
        invitesShown: [],
        phase: 'form'
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadUser();
    };

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        // Start loading.
        this.setState({
            loading: true
        });

        // Request the data.
        const response = await Me.getMe({
            includeHasInvited: true,
            user_id
        });

        // Increment the invites array keys as we are 1 based for this form.
        let invites = [];

        if (response.data.data.has_invited) {
            for (var i=0; i < response.data.data.has_invited.length; i++) {
                invites[i+1] = response.data.data.has_invited[i];
            }
        }

        // Set the form values.
        this.props.setForm({
            ...response.data.data,
            invites,
            user_id
        });

        // Finish loading.
        this.setState({
            loading: false
        });
    }

    /**
     * @method getFormValues
     * @param {integer|null} index
     * @return {object}
     */
    getFormValues = (index) => {
        const {form} = this.props;

        return index !== null ?
            (form['invites'] && form['invites'][index] ?
                form['invites'][index] :
                null) :
            form;
    }

    /**
     * @method getFormkey
     * @param {integer|null} index
     * @return {string}
     */
    getFormkey = (index) => {
        return index !== null ?
            'invites.' + index + '.' :
            '';
    }

    /**
     * @method handleToggleInvite
     * @param {integer} index
     */
    handleToggleInvite = (index) => {
        const {invitesShown} = this.state;
        this.setState({
            invitesShown: {
                ...invitesShown,
                [index]: !invitesShown[index]
            }
        });
    }

    /**
     * @method handleSuccess
     */
    handleSuccess = () => {
        this.handlePhaseChange('success');
    }

    /**
     * @method handlePhaseChange
     * @param {string} phase
     */
    handlePhaseChange = (phase) => {
        this.loadUser();

        this.setState({
            phase
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {user_id, phase} = this.state;

        if (user_id) {
            return (
                <AdminLayout title='Users - Profile'>
                    {this.renderPhase()}
                </AdminLayout>
            );
        }

        return (
            <SettingsLayout title="Registration">
                <div>
                    <h1 className="text-app-blue-light text-4xl my-8 text-center">
                        {phase === 'success' ? 'Thank You' : 'Registration'}
                    </h1>

                    {this.renderPhase()}
                </div>
            </SettingsLayout>
        );
    }

    /**
     * @method renderPhase
     * @return {JSX.Element}
     */
    renderPhase() {
        const {phase} = this.state;

        if (phase === 'success') {
            return this.renderSuccess();
        }

        return this.renderPage();
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderPage () {
        const {loading} = this.state;
        const {form, working, alert, handleInput, handleSubmit} = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <form
                autoComplete="off"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(e, Me.update, this.handleSuccess);
                    window.scrollTo(0, 0);
                }}
            >
                {alert !== null && (<Alert {...alert} />)}

                <div className="text-center font-light mt-8 mb-4">
                    {form.first_group_name === 'Store Manager' &&
                        <>
                            <p className="mb-2">
                                To register yourself (Store manager) and your Store team member for the Fragrance event on
                                {User.data.attending_date ?? 'Tuesday 3rd October and ' + 'Wednesday 4th October'},
                                please check your details are correct and enter your Store team members details.
                                <br/>
                                {/*{form.profile_completed &&*/}
                                {/*    <>*/}
                                {/*        Hi {form.store_number}. {form.full_name} has registered the following people for your store to attend the event at [LOCATION, DATE, TIMINGS].*/}
                                {/*    </>*/}
                                {/*}*/}
                            </p>

                            <p className="text-center font-light mb-4 mt-8">
                                You have {form.number_of_invites} invites for your store available.
                                This allocation includes yourself (Store Manager).
                                 Please register your details in ‘Your Details’ Section below.
                                If you cannot attend, you can let us know below or register
                                your Deputy Manager or another Store Team Member.
                                Please then register your additional Store team member that will be attending.
                            </p>
                        </>
                    }

                    {form.first_group_name !== 'Store Manager' &&
                        <p className="mb-2">
                            To register your attendance for the Fragrance Event on {User.data.attending_date ?? 'Tuesday 3rd October and ' +
                            'Wednesday 4th October'}, please complete the registration fields below.
                        </p>
                    }

                    <p className="font-bold text-lg">
                        Please click{" "}
                        <Link
                            to="/venues"
                            target="_blank"
                            className="underline"
                        >
                            here
                        </Link>
                        {" "}to view the venue information.
                    </p>

                    {/*form?.venue &&
                        <p className="font-bold text-lg">
                            {form?.venue}
                        </p>
                    */}
                </div>

                <div className="p-6">
                    {/*{alert !== null && (<Alert {...alert} />)}*/}

                    {this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                            value={form.avatar_path}
                            onChange={v => handleInput('avatar_path', v)}
                            accept="image/*"
                            placeholder="Update Picture"
                            fallbackImage={getFallbackAvatarUrl(form)}
                        />
                    }

                    {this.renderForm(null)}

                    {form.number_of_invites > 0 && this.renderInvites()}
                </div>

                <div className="p-6 flex justify-between">
                    <PrimaryButton
                        text="Save"
                        working={working}
                        type="submit"
                    />
                </div>

                <div className="p-6 font-light">
                    <p>
                        If you have any questions about the event, please contact <MailLink to="bootsevents@top-b.com" />
                    </p>
                </div>
            </form>
        );
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderInvites () {
        const {invitesShown} = this.state;
        const {form, getFieldError, handleInput} = this.props;

        return (
            <>
                {/*<p className="text-center font-light mb-4 mt-8">*/}
                {/*    You have {form.number_of_invites} invites for your store available.*/}
                {/*    Please register your details in ‘Your Details’ Section below. If you cannot attend,*/}
                {/*    you can let us know below or register your Deputy Manager or another Store Team Member.*/}
                {/*    Please then register your additional Store team member that will be attending.*/}
                {/*</p>*/}

                {[...Array(form.number_of_invites)].map((e, i) => (
                    <div key={i}>
                        <div
                            className={`
                                text-3xl bg-app-blue-dark text-white w-full cursor-pointer px-4 py-2 mt-8 mb-4
                                select-none flex flex-row justify-between items-center
                            `}
                            onClick={() => this.handleToggleInvite(i)}
                        >
                            <p>
                                {i === 0 ? "Your Details" : "Store Team Member "}
                            </p>

                            <FontAwesomeIcon
                                icon={invitesShown[i] ? faCaretUp : faCaretDown}
                            />
                        </div>

                        {invitesShown[i] &&
                            <div className="bg-white border border-black p-4">
                                {this.renderForm((i+1))}
                            </div>
                        }
                    </div>
                ))}

                {/*<BooleanSelect
                    containerClassName="mt-8"
                    label="Have you filled in all the invites that you will be using?"
                    value={form.profile_completed}
                    id="profile_completed"
                    error={getFieldError('profile_completed')}
                    onChange={(v) => handleInput('profile_completed', v)}
                />*/}
                <div className="my-auto p-4 bg-app-danger-red">
                    <Checkbox
                        label={"I HAVE NOW COMPLETED THE REGISTRATION FOR THE EVENT FOR MYSELF AND THE ADVISORS ATTENDING"}
                        value={form.profile_completed === true}
                        id="profile_completed"
                        error={getFieldError('profile_completed')}
                        onChange={(v) => handleInput('profile_completed', true)}
                        containerClassName={"font-bold text-2xl"}
                        className={"font-bold text-xl"}
                    />
                </div>
                <div className="my-auto p-4 bg-app-danger-red">
                    <Checkbox
                        label={"I NEED TO COME BACK AT A LATER DATE AND COMPLETE THE REGISTRATION FOR MYSELF AND THE ADVISORS ATTENDING"}
                        value={form.profile_completed === false}
                        id="profile_completed_false"
                        error={getFieldError('profile_completed')}
                        onChange={(v) => handleInput('profile_completed', false)}
                        containerClassName={"font-bold text-2xl"}
                        className={"font-bold text-2xl"}
                    />
                </div>
            </>
        );
    }
    async deleteAdvisor( index, key ) {

        this.setState ( {
            loading: true
        } );

        const response = await Me.removeAdvisor (
            this.props.form.invites[index].id
        );

        if ( response.success ) {
            this.props.form[ index ] = {};
            this.restAdvisorForm(index, key);
        }

        this.setState ( {
            loading: false
        } );
    }


    restAdvisorForm( index,key ) {
        const {handleInput} = this.props;

        //only way for the reset form to work. Manually do it
        handleInput(key + 'employee_number', null);
        handleInput(key + 'email', null);
        handleInput(key + 'first_name', null);
        handleInput(key + 'last_name', null);
        handleInput(key + 'position', null);
        handleInput(key + 'accommodation', null);
        handleInput(key + 'accommodation_postcode', null);
        handleInput(key + 'dietaries', null);
        handleInput(key + 'special_access_requirements', null);
        handleInput(key + 'emergency_contact_details', null);
        handleInput(key + 'travel', null);
        handleInput(key + 'reason_can_not_attend', null);

        this.props.form.invites[index]=null;
        delete this.props.form.invites[index];
    }
    /**
     * @method renderPage
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderForm (index, group_name) {
        const {getFieldError, handleInput} = this.props;
        const {clearForm} = this.state;

        let values = this.getFormValues ( index );

        let key = this.getFormkey(index);
        // Store Manager group.
        if (values?.first_group_name === 'Store Manager') {
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    {this.renderStoreManagerForm(values, key)}
                </div>
            );
        }

        // The four support groups.
        if ([
            'Support Office',
            'Field Based Role',
        ].includes(values?.first_group_name)) {
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    {this.renderAttendingForm(values, key)}
                </div>
            );
        }
        let options = [];
        if (index == 1  ) {
            options = [
                {
                    label: 'Yes',
                    value: 'Yes'
                },
                {
                    label: 'No',
                    value: 'No'
                },
                {
                    label: 'Nominate Deputy Manager',
                    value: 'Nominate Deputy Manager',
                },
                {
                    label: 'Nominate Store Team Member',
                    value: 'Nominate Store Team Member',
                },
            ];
        } else {
            options = [
                {
                    label: 'Yes',
                    value: 'Advisor'
                },
                {
                    label: 'No',
                    value: 'No'
                }
            ];
        }
        // If not in one of the above groups.
        return (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <>
                    <Select
                        containerClassName="col-span-2"
                        label= {index > 1 ? "Do you need this space?" : "Will you be attending?" }
                        value={values?.invite_type}
                        id="invite_type"
                        error={getFieldError(key + 'invite_type')}
                        onChange={(v) => handleInput(key + 'invite_type', v)}
                        options={options}
                    />

                    { ['No'].includes(values?.invite_type) &&
                        <Textarea
                            label={`
                                If you are not attending; please complete the box below as to why you can not attend.
                            `}
                            value={values?.reason_can_not_attend}
                            id="reason_can_not_attend"
                            error={getFieldError(key + 'reason_can_not_attend')}
                            onChange={(v) => handleInput(key + 'reason_can_not_attend', v)}
                            required={values?.profile_completed || values?.first_group_name !== 'Store Manager'}
                            key={'reason_can_not_attend' + key}
                            containerClassName="col-span-2"
                        />
                    }
                </>


                {(['Nominate Deputy Manager', 'Nominate Store Team Member' , 'Yes', 'Advisor'].includes(values?.invite_type)) && (
                    this.renderCommonForm(values, key, index == 1)
                )}

                {!this.props.form.invites[index]?.id &&
                    <SecondaryButton
                        type="button"
                        onClick={(e) => this.restAdvisorForm(index, key)}
                        text={"clear form"}
                        className={"w-1/3 col-span-2"}
                    />
                }
                {/*{this.props.form?.invites[index] && this.props.form?.invites[index]?.id && index > 1 &&*/}
                {/*    <ModalTrigger*/}
                {/*        component={Confirm}*/}
                {/*        props={{*/}
                {/*            onConfirm: (e) => this.deleteAdvisor(index,key),*/}
                {/*            message: "Are you sure you want to delete this advisor " + this.props.form?.invites[index]?.full_name + "?"*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <SecondaryButton*/}
                {/*            text="Delete Advisor"*/}
                {/*            className={"w-1/3 col-span-2"}*/}
                {/*            type="button"*/}
                {/*        />*/}
                {/*    </ModalTrigger>*/}
                {/*}*/}
            </div>
        );
    }

    /**
     * @method renderStoreManagerForm
     * @param {object} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderStoreManagerForm(values, key) {
        const {getFieldError, handleInput} = this.props;

        return (
            <>
                <Input
                    label="Store Number"
                    value={values?.store_number}
                    id="store_number"
                    error={getFieldError(key + 'store_number')}
                    onChange={(v) => handleInput(key + 'store_number', v)}
                    readOnly={true}
                />

                <Input
                    label="Store Name"
                    value={values?.store_name}
                    id="store_name"
                    error={getFieldError(key + 'store_name')}
                    onChange={(v) => handleInput(key + 'store_name', v)}
                    readOnly={true}
                />

                <Input
                    label="Email"
                    value={values?.email}
                    id="email"
                    error={getFieldError(key + 'email')}
                    onChange={(v) => handleInput(key + 'email', v)}
                    readOnly={!window.base.features.allow_email_change && !key}
                />

                <Input
                    label="Region"
                    value={values?.region}
                    id="region"
                    error={getFieldError(key + 'region')}
                    onChange={(v) => handleInput(key + 'region', v)}
                    readOnly={true}
                />
            </>
        );
    }

    /**
     * @method renderAttendingForm
     * @param {object} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderAttendingForm(values, key) {
        const {getFieldError, handleInput} = this.props;

        return (
            <>
                <BooleanSelect
                    containerClassName="col-span-2"
                    label="Will you be attending"
                    value={values?.attending}
                    id="attending"
                    error={getFieldError(key + 'attending')}
                    onChange={(v) => handleInput(key + 'attending', v)}
                />

                {values?.attending === false &&
                    <Textarea
                        containerClassName="col-span-2"
                        label="Please complete the box below as to why you can not attend."
                        value={values?.reason_can_not_attend}
                        id="reason_can_not_attend"
                        error={getFieldError(key + 'reason_can_not_attend')}
                        onChange={(v) => handleInput(key + 'reason_can_not_attend', v)}
                    />
                }

                {values?.attending === true &&
                    this.renderCommonForm(values, key, true)
                }
            </>
        );
    }

    /**
     * @method renderCommonForm
     * @param {object} values
     * @param {string} key
     * @param {boolean} me
     * @return {JSX.Element}
     */
    renderCommonForm(values, key, me) {
        const {getFieldError, handleInput, form} = this.props;

        return (
            <>
                {me && User.data.first_group_name === 'Store Manager' &&
                    <Input
                        label="Employee Number"
                        value={values?.employee_number}
                        id="employee_number"
                        error={getFieldError(key + 'employee_number')}
                        onChange={(v) => handleInput(key + 'employee_number', v)}
                        required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />
                }

                { ( ( !me && User.data.first_group_name === 'Store Manager' ) || (User.data.first_group_name !== 'Store Manager') )  && (
                    <Input
                        label="Email"
                        value={values?.email}
                        id="email"
                        error={getFieldError(key + 'email')}
                        onChange={(v) => handleInput(key + 'email', v)}
                        readOnly={!window.base.features.allow_email_change}
                    />
                )
                }

                <Input
                    label="First Name"
                    value={values?.first_name}
                    id="first_name"
                    error={getFieldError(key + 'first_name')}
                    onChange={(v) => handleInput(key + 'first_name', v)}
                    required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                    containerClassName={"col-span-2 md:col-span-1"}
                />

                <Input
                    label="Last Name"
                    value={values?.last_name}
                    id="last_name"
                    error={getFieldError(key + 'last_name')}
                    onChange={(v) => handleInput(key + 'last_name', v)}
                    required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                    containerClassName={"col-span-2 md:col-span-1"}
                />

                <Input
                    label="Position"
                    value={values?.position}
                    id="position"
                    error={getFieldError(key + 'position')}
                    onChange={(v) => handleInput(key + 'position', v)}
                    required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                    containerClassName={"col-span-2 md:col-span-1"}
                />
                <div className={"col-span-2"}>
                     <p className="font-bold">
                        Accommodation
                    </p>

                    <BooleanSelect
                        label={me ?
                            "Do you require accommodation, this should be based on needing to travel more than 3 hours from your store" :
                            "Does the attendee require accommodation, this should be based on needing to travel more than 3 hours from your store"
                        }
                        value={values?.accommodation}
                        id="accommodation"
                        error={getFieldError(key + 'accommodation')}
                        onChange={(v) => handleInput(key + 'accommodation', v)}
                        required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />

                    {values?.accommodation &&
                        <Input
                            label={me ?
                                "Please provide a postcode for where you are travelling from" :
                                "Please provide a postcode for where the attendee is travelling from"
                            }
                            value={values?.accommodation_postcode}
                            id="accommodation_postcode"
                            error={getFieldError(key + 'accommodation_postcode')}
                            onChange={(v) => handleInput(key + 'accommodation_postcode', v)}
                            required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                            containerClassName={"col-span-2 md:col-span-1"}
                        />
                    }
                </div>

                <div className="col-span-2">
                    <Dietaries
                        label="Dietaries"
                        value={values?.dietaries}
                        id="dietaries"
                        error={getFieldError(key + 'dietaries')}
                        onChange={(v) => handleInput(key + 'dietaries', v)}
                        me={me}
                        required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />
                </div>

                <div className="col-span-2">
                    <SpecialRequirements
                        label="Special Access Requirements"
                        value={values?.special_access_requirements}
                        id="special_access_requirements"
                        error={getFieldError(key + 'special_access_requirements')}
                        onChange={(v) => handleInput(key + 'special_access_requirements', v)}
                        me={me}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />
                </div>

                <div className="col-span-2">
                    <TravelDetails
                        label="Travel"
                        value={values?.travel}
                        id="travel"
                        error={getFieldError(key + 'travel')}
                        onChange={(v) => handleInput(key + 'travel', v)}
                        me={me}
                        required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />
                </div>

                <div className="col-span-2">
                    <EmergencyContactDetails
                        label="Emergency Contact Details"
                        value={values?.emergency_contact_details}
                        id="emergency_contact_details"
                        error={getFieldError(key + 'emergency_contact_details')}
                        onChange={(v) => handleInput(key + 'emergency_contact_details', v)}
                        me={me}
                        required={(form?.first_group_name === 'Store Manager' && form.profile_completed === true) || form?.first_group_name !== 'Store Manager'}
                        containerClassName={"col-span-2 md:col-span-1"}
                    />
                </div>
            </>
        );
    }

    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess() {
        const {form} = this.props;

        return (
            <div className="text-center mt-8">
                {form.first_group_name === 'Store Manager' && !form.profile_completed &&
                    <>
                        <p className="font-bold mb-4">
                            Thank you!
                        </p>
                        <p className="mb-4">
                            Make sure you return to the site to complete all the advisors details for the event.
                            You can do this until Friday 22nd September 2023.
                        </p>
                    </>
                }

                {form.first_group_name === 'Store Manager' && form.profile_completed &&
                    <p className="font-bold mb-4">
                         You have successfully registered the following to attend the Fragrance event.
                    </p>
                }

                {form.first_group_name === 'Store Manager' && form['invites'].length > 0 && form.profile_completed && (

                    <table className={"mx-auto border-spacing-3 border "} key={"userInviteTable"}>
                        <thead>
                                <tr>
                                    <th className={"p-4"}>Type</th>
                                    <th className={"p-4"}>First Name</th>
                                    <th className={"p-4"}>Last Name</th>
                                    <th className={"p-4"}>Store Number</th>
                                    <th className={"p-4"}>Employee Number</th>
                                </tr>
                            </thead>
                        <tbody>
                            {form['invites']
                                .map((invite, index) => (
                                <>
                                    {invite.invite_type === 'No' && (
                                        <tr className={"mx-auto"}>
                                            <td colSpan={4} className={"p-4 span-5 text-left"}>{ index === 1 ? 'Store/Deputy Manager not attending' : 'Store Team Member not attending'}</td>
                                        </tr>
                                    )}

                                    {/*{ invite.invite_type === 'Nominate Deputy Manager' && (*/}
                                    {/*    <tr className={"mx-auto"}>*/}
                                    {/*        <td colSpan={4} className={"p-4"}>Nominated Deputy Manager</td>*/}
                                    {/*    </tr>*/}
                                    {/*)}*/}

                                    {(invite.invite_type === 'Yes' || invite.invite_type === 'Advisor' || invite.invite_type === 'Nominate Deputy Manager' || invite.invite_type ==='Nominate Store Team Member') && (
                                        <tr className={"mx-auto"}>
                                            <td className={"p-4"}>{ index === 1 ? 'Store/Deputy Manager' : 'Store Team Member ' }</td>
                                            <td className={"p-4"}>{ invite.first_name }</td>
                                            <td className={"p-4"}>{ invite.last_name }</td>
                                            <td className={"p-4"}>{ form.store_number ?? null }</td>
                                            <td className={"p-4"}>{ invite.employee_number }</td>
                                        </tr>
                                    )}
                                </>
                            )) }
                        </tbody>
                    </table>
                )}

                {form.first_group_name !== 'Store Manager' &&
                    <p className="font-bold mb-4">
                        {form.attending === false ?
                            'Thank you for registering that you will not be attending the Fragrance Event.' :
                            'You have successfully registered to attend the Fragrance Event.'
                        }
                    </p>
                }

                {((form.attending === true  && form.first_group_name !== 'Store Manager')  ||  form.profile_completed === true && form.first_group_name === 'Store Manager')  && (
                    <>
                        <p className="mb-4">
                            A confirmation email has been sent to your email address.
                        </p>
                        <p className="font-light mb-4">
                            If you do not see the email in a few minutes,
                            please check your junk inbox in case it has slipped into this folder.
                        </p>

                        <p>
                            Joining instructions will be sent with additional venue and event information week commencing 25th September 2023.
                            Please see here for further information on the venue and travel.
                        </p>
                    </>
                )}
                {/*{ form.profile_completed && (*/}
                {/*    <p className="font-light mb-4">*/}
                {/*        A confirmation email has been sent to your email address.*/}
                {/*    </p>*/}
                {/*)}*/}

                {/*{form.first_group_name === 'Store Manager' && form.profile_completed === false &&
                    <>
                        <p>
                            Joining instructions will be sent with additional venue and event information on Wednesday 1st March 2023.
                            Please see <Link to="/venues" className="underline cursor-pointer">here</Link>{" "}
                            for further information on the venue and travel.
                        </p>
                    </>
                }*/}

                <p className="font-light mb-8">
                    If you have any questions about the event, please contact <MailLink to="bootsevents@top-b.com" />
                </p>

                <PrimaryButton
                    text="Update"
                    onClick={() => this.handlePhaseChange('form')}
                />
            </div>
        );
    }
}

export default FormHandler(Profile);
